import { COPORATE_PREFIX_ARR, COMPANY_TYPE_ARR } from "@/constants/COMPANY";

export const getFullCompanyName = (corporate_type, company_name) => {
  let name = "";
  const prefixMap = new Map(COPORATE_PREFIX_ARR.map((el) => [el.id, el.name]));
  const prefix = prefixMap.get(corporate_type);
  name = prefix
    ? prefix
        .replace("（会社名）", company_name)
        .replace("（登記名or個人名）", company_name)
    : company_name;
  return name;
};

export const handleCompanyType = (company_type) => {
  const company = COMPANY_TYPE_ARR.find((item) => item.id == company_type);
  return company?.name;
};
